<template>
  <!-- <div style="margin-top: 0.78rem">_id.vue_id.vue_id.vue_id.vue</div> -->

  <section class="main lh-15">
    <div class="banner blog-banner p-r">
      <div class="banner-text-wrap">
        <strong class="m-0 fw-700 ta-c c-fff banner-title">Blog <i></i></strong>
      </div>
    </div>
    <div class="container w-1200r m-a">
      <div class="crumb d-f jc-fs ai-c ff-asl pl-60 in-pc">
        <a class="c-333" href="/">Home</a><span class="c-999"></span><a class="c-333 ff-as" href="/blog">News</a>
      </div>

      <div class="content d-f jc-sb ai-fs">
        <section class="left-content bgc-fff">
          <div class="left-content-in">
            <h1 class="main-title ff-asb c-000">
              {{ blogDetailData.title }}
            </h1>
            <div class="date d-f ai-c">
              {{ blogDetailData.updateTime | formatDate }}
              <div class="share-box d-f ai-c">
                <div
                  class="share-ico d-ib c-p bgs-cover"
                  @mouseenter="mouseenterShare"
                  @mouseleave="mouseleaveShare"
                ></div>
                <!-- <div class="share-container d-n ai-c"></div> -->
                <div
                  class="share-container ai-c"
                  @mouseenter="mouseenterShare"
                  @mouseleave="mouseleaveShare"
                  v-show="showShareWrap"
                >
                  <a
                    v-for="(shareItem, idx) in shareIcon"
                    :key="idx"
                    href="javascript:;"
                    :data-site="shareItem.site"
                    :class="shareItem.className"
                    @click="processShare(shareItem.site)"
                    class="d-ib bgs-cover"
                  ></a>
                </div>
              </div>
            </div>
            <div class="article" v-html="blogDetailData.textContent"></div>
            <div class="pagination d-f ai-c jc-c">
              <a
                class="d-f ai-c jc-c p-r prev able"
                :class="!blogDetailData.prevUrl ? 'disable' : ''"
                :href="blogDetailData.prevUrl ? blogDetailData.prevUrl.replace('.html', '') : 'javascript:;'"
                ><span>Previous</span></a
              >
              <a
                class="d-f ai-c fd-r jc-c p-r next able"
                :class="!blogDetailData.nextUrL ? 'disable' : ''"
                :href="blogDetailData.nextUrL ? blogDetailData.nextUrL.replace('.html', '') : 'javascript:;'"
                ><span>Next</span></a
              >
            </div>
          </div>
          <!-- 右边板块 -->
        </section>
        <section class="right-content">
          <div class="recent-posts bgc-fff">
            <div class="right-content-in">
              <div class="right-title"><strong class="fw-700 ff-asb c-000">Recent Posts</strong></div>
              <ul class="ov-h" id="recent-list">
                <li
                  v-for="(postsItem, index) in recentPostsData"
                  :key="index"
                  @click="viewRecentPosts(postsItem.url, postsItem.id)"
                >
                  <!-- {{ recentPostsData }} -->
                  <a class="d-f jc-sb cu-p" :href="postsItem.url ? postsItem.url.replace('.html', '') : 'javascript:;'">
                    <div>
                      <span href="" class="c-262626 d-ib ellipsis wlc-3 fw-500">
                        {{ postsItem.title }}
                      </span>
                      <div class="date">{{ postsItem.releaseTime }}</div>
                    </div>
                    <span class="c-262626 d-ib img-box cu-p">
                      <img v-lazy="postsItem.coverImg" width="100%" height="100%" :alt="postsItem.title" />
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <!-- recent-posts:end  -->
          <div class="related-products bgc-fff">
            <div class="right-content-in">
              <div class="right-title"><strong class="fw-700 ff-asb c-000">Related Products</strong></div>
              <div class="related-products-swiper p-r ov-h">
                <div class="swiper-wrapper" id="related-products-list">
                  <client-only>
                    <swiper class="" :options="swiperOption" ref="swiper">
                      <swiper-slide v-for="(swiperItem, index) in swiperData" :key="index">
                        <a
                          :href="swiperItem.detailsUrl ? swiperItem.detailsUrl.replace('.html', '') : 'javascript:;'"
                          class="img-box d-b"
                        >
                          <img :src="swiperItem.picture" width="100%" height="100%" :alt="swiperItem.productName" />
                        </a>
                        <a
                          class="product-title d-b fw-700 d-f ai-c"
                          :href="swiperItem.detailsUrl ? swiperItem.detailsUrl.replace('.html', '') : 'javascript:;'"
                        >
                          <i class="link-icon d-ib bgs-cover"></i><span>{{ swiperItem.productName }} </span>
                        </a>
                        <div class="ellipsis wlc-3">
                          {{ swiperItem.productDescribe }}
                        </div>
                      </swiper-slide>
                    </swiper>
                  </client-only>
                </div>

                <!-- <ul class="swiper-wrapper" id="related-products-list">
                  <li class="swiper-slide">
                    <a href="" class="img-box d-b">
                      <img
                        v-lazy="require('@/assets/images/aerialmapper/area-8-1.jpg')"
                        width="100%"
                        height="100%"
                        alt=""
                      />
                    </a>
                    <a class="product-title d-b fw-700 d-f ai-c" href="http://">
                      <i class="link-icon d-ib bgs-cover"></i><span>RTK BASE STATION Provide radio </span>
                    </a>
                    <div class="ellipsis wlc-3">
                      Provide radio RTK signal to correct GNSS signal, achieve 2.5cm accuracy of pieve 2.5cm accuracy of
                      p ieve 2.5cm accuracy of pieve 2.5cm accuracy of positioning.
                    </div>
                  </li>
                </ul> -->
                <div class="related-products-swiper-pagination p-a"></div>
              </div>
            </div>
          </div>
          <!-- related-products:end   -->

          <div class="push-ads d-n bgc-fff">
            <div class="right-content-in">
              <ul class="ov-h" id="push-ads-list">
                <li>
                  <a href="" class="img-box d-b">
                    <img
                      v-lazy="require('@/assets/images/aerialmapper/area-8-1.jpg')"
                      width="100%"
                      height="100%"
                      alt=""
                    />
                  </a>
                  <a href="" class="push-ads-title d-b fw-700 ellipsis wlc-2">
                    FJDynamics Launches E-fence and Assisted Mode for 3D Excavator 3D Excavator 3D Excavator
                  </a>
                  <div class="date d-f ai-c">
                    <span class="tag c-fff d-ib ta-c">Company News</span>
                    March 24/2022
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- push-ads：end -->

          <div class="right-share bgc-fff">
            <div class="right-content-in">
              <div class="c-000 fw-700">share on:</div>
              <div class="share-container d-f ai-c">
                <a
                  v-for="(shareItem, idx) in shareIcon"
                  :key="idx"
                  href="javascript:;"
                  :data-site="shareItem.site"
                  :class="shareItem.className"
                  @click="processShare(shareItem.site)"
                  class="d-ib bgs-cover"
                ></a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
  import bannerScroll from '@/mixins/bannerScroll.js'

  export default {
    key(route) {
      return route.fullPath
    },
    mixins: [bannerScroll],
    async asyncData(context) {
      // console.log(context, 'context')
      const { params } = context.route
      const blogId = params['id'].split('-')[0]
      // console.log('[ blogId ] >', blogId)
      try {
        // 获取相关产品数据 轮播
        const { data: swiperData } = await context.$api.blogApi.getByProductId({
          language: 'en-US',
          blogId
        })
        // console.log('[ swiperData ] >', swiperData)
        // 获取最近3 blog条数据
        const { data: recentPostsData } = await context.$api.blogApi.getBlogData({
          languageCode: 'en-US',
          blogCategory: 1
        })
        // console.log('[ recentPostsData ] >', recentPostsData)
        // getDetailBlog
        const { data: blogDetailData } = await context.$api.blogApi.getDetailBlog(blogId)
        console.log('[ blogDetailData ] >', blogDetailData)
        return {
          blogDetailData: blogDetailData || [],
          swiperData: swiperData || [],
          recentPostsData: recentPostsData || []
        }
      } catch (error) {
        console.log('[ error ] >', error)
      }
      // console.log('[ recentPostsData ] >', recentPostsData)
      // return {
      //   swiperData: data.data || [],
      //   recentPostsData: recentPostsData.data
      // }
    },
    data() {
      return {
        blogData: [],
        recentPostsData: [],
        blogDetailData: [],
        showShareWrap: false,
        timer: null,
        swiperOption: {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 10,
          effect: 'slide',
          observer: true, // 修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, // 修改swiper的父元素时，自动初始化swiper
          observeSlideChildren: true,
          autoplay: {
            delay: 4000
          },
          pagination: {
            el: '.related-products-swiper-pagination',
            clickable: true
          }
        },
        swiperData: [],
        shareIcon: [
          {
            site: 'facebook',
            className: 'facebook-black'
          },
          {
            site: 'linkedin',
            className: 'linkedin-black'
          },
          {
            site: 'twitter',
            className: 'twitter-black'
          }
        ]
      }
    },
    head() {
      return {
        title: 'Blog - FJDynamics',
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'farm machinery,RTK,precision farming,autopilot,Autosteering kit '
          },
          // hid is used as unique identifier. Do not use `vmid` for it as it will not work
          {
            hid: 'description',
            name: 'description',
            content: 'Latest FJDynamics news, product updates, and customer success sotries. '
          }
        ]
      }
    },
    created() {
      console.log('[created this.swiperData ] >', this.swiperData)
    },
    mounted() {
      console.log('[mounted this.swiperData ] >', this.swiperData)
    },
    destroyed() {
      console.log('[destroyed this.swiperData ] >', this.swiperData)
    },
    methods: {
      mouseenterShare() {
        if (this.timer) clearTimeout(this.timer)
        this.showShareWrap = true
        // console.log('[ this.getMetaContent() ] >', this.getMetaContent('keywords'))
      },
      mouseleaveShare() {
        this.timer = setTimeout(() => {
          this.showShareWrap = false
        }, 200)
      },
      // getBlogData  getByProductId 产品
      processShare(key) {
        const options = {
          url: document.location.href || '',
          title: document.title || '',
          desc: this.getMetaContent('description') || '',
          source: 'fjdynamics',
          origin: location.origin || ''
        }

        const siteMap = {
          facebook: `https://www.facebook.com/sharer/sharer.php?u=${options.url}&t=${options.title}`,
          linkedin: `http://www.linkedin.com/shareArticle?mini=true&ro=true&title= ${options.title}&url= ${options.url}&summary= ${options.desc}&source= ${options.source}&armin=armin`,
          twitter: `https://twitter.com/intent/tweet?text=${options.title}&url=${options.url}&via=${options.origin}`
        }
        this.openWindow(siteMap[key])
      },
      openWindow(url) {
        const ww = document.documentElement.clientWidth
        const wh = document.documentElement.clientHeight
        const iWidth = ww * 0.5
        const iHeight = wh * 0.7
        const iLeft = Number(ww - iWidth) / 2
        const iTop = Number(wh - iHeight) / 2

        window.open(
          url,
          '',
          'width=' +
            iWidth +
            ',height=' +
            iHeight +
            ',top=' +
            iTop +
            ',left=' +
            iLeft +
            ',toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no'
        )
      },
      getMetaContent(key) {
        const metas = document.getElementsByTagName('meta')
        return metas[key]['content'] || ''
      },
      viewRecentPosts(url, id) {
        const notHtmlUrl = url.replace('.html', '')
        this.$router.push({ path: `${notHtmlUrl}`, params: { id } })
      }
      // hanlderPrev(prevId, prevUrl) {
      //   if (!prevUrl) return
      //   this.$router.push({ path: `/blog/${prevUrl}`, params: { blogId: prevId } })
      // },
      // hanlderNext(nextId, nextUrL) {
      //   // const languageCode = this.$i18n.loadedLanguages[0] || 'en'
      //   if (!nextUrL) return
      //   this.$router.push({ path: `/blog/${nextUrL}`, params: { blogId: nextId } })
      // }
    }
  }
</script>

<style scoped lang="scss">
  .disable {
    color: #999;
    border: 1px solid #999;
  }
  .main {
    padding-top: 3.9583vw;
    background-color: #fafafb;
  }
  .blog-banner {
    height: 3.6rem;
    background: url('@/assets/images/blog/blog-banner.jpg') no-repeat center;
    background-size: cover;
  }
  .banner-text-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    text-align: center;
    line-height: 1.5;
    transform: translate(-50%, -50%);
  }
  .banner-title {
    font-size: 0.48rem;
    line-height: 1.5;
  }

  .container {
    padding-bottom: 0.95rem;
  }

  .crumb {
    padding: 0.32rem 0 0.24rem;
    font-size: 0.16rem;
    display: flex;
    align-items: center;
    line-height: 1;
  }
  .crumb a:hover {
    color: #333;
  }

  .content {
    color: rgba(0, 0, 0, 0.65);
    font-size: 0.16rem;
  }
  .content a {
    color: #262626;
  }
  .content a:hover {
    color: #000;
  }
  .left-content {
    width: 8.43rem;
    border-radius: 0.08rem;
  }
  .left-content-in {
    padding: 0.22rem 0.32rem;
  }
  .left-content .main-title {
    font-size: 0.32rem;
    margin-bottom: 0.12rem;
    font-weight: 700;
  }
  .share-ico {
    transition: transform 0.3s;
    width: 0.24rem;
    height: 0.24rem;
    margin-right: 0.1rem;
    margin-left: 0.1rem;
  }
  .share-ico:hover {
    transform: scale(1.2);
  }
  .share-container {
    height: 0.24rem;
  }
  .share-box .share-container a {
    width: 0.24rem;
    height: 0.24rem;
    margin: 0 0.1rem;
  }
  .left-content .date {
    margin-bottom: 0.32rem;
    color: #8c8c8c;
  }
  .pagination {
    padding: 0.6rem 0 0.32rem;
  }
  .pagination .disable {
    color: #999;
    border: 1px solid #999;
    cursor: not-allowed;
  }
  .pagination .able {
    flex: 0 0 auto;
    margin: 0 0.4rem;
    width: 1.4rem;
    text-align: center;
    line-height: 0.42rem;
    font-size: 0.16rem;
    box-sizing: border-box;
    border: 1px solid rgba(34, 34, 34, 1);
    cursor: pointer;
  }
  .pagination .able::before {
    flex: 0 0 auto;
    position: relative;
    transition: transform 0.2s linear;
    content: '';
    display: inline-block;
    width: 0.24rem;
    height: 0.24rem;
    background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M24 0H0v24h24z'/%3E%3Cpath d='M8.957 11.299l3.586-3.586a1 1 0 0 1 1.707.707v7.172a1 1 0 0 1-1.707.707l-3.586-3.586a1 1 0 0 1 0-1.414z' fill='%23222'/%3E%3C/g%3E%3C/svg%3E");
    background-size: cover;
  }
  .pagination .able:hover::before {
    transform: translateX(-0.05rem);
  }
  .pagination .prev::before {
    left: -0.1rem;
  }
  .pagination .disable {
    flex: 0 0 auto;
    margin: 0 0.4rem;
    width: 1.4rem;
    text-align: center;
    line-height: 0.42rem;
    font-size: 0.16rem;
    box-sizing: border-box;
    cursor: not-allowed;
    // border: 1px solid rgba(34, 34, 34, 1);
    border: 1px solid #999;
    &:hover span {
      color: #999;
    }
    &::before {
      flex: 0 0 auto;
      position: relative;
      transition: transform 0.2s linear;
      content: '';
      display: inline-block;
      width: 0.24rem;
      color: #999;
      height: 0.24rem;
      background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M24 0H0v24h24z'/%3E%3Cpath d='M8.957 11.299l3.586-3.586a1 1 0 0 1 1.707.707v7.172a1 1 0 0 1-1.707.707l-3.586-3.586a1 1 0 0 1 0-1.414z' fill='%23999'/%3E%3C/g%3E%3C/svg%3E");
      background-size: cover;
    }
  }
  .pagination .next::before {
    right: -0.1rem;
    transform: rotate(180deg);
  }
  .pagination .next:hover::before {
    transform: translateX(0.05rem) rotate(180deg);
  }

  .right-content {
    width: 3.33rem;
  }
  .right-content-in {
    padding: 0.24rem 0.16rem 0;
  }
  .related-products .right-content-in {
    padding: 0.24rem 0.16rem 0.32rem 0.16rem;
  }
  .right-title {
    font-size: 0.24rem;
  }
  .recent-posts,
  .related-products,
  .push-ads,
  .detail-share {
    margin-bottom: 0.24rem;
    border-radius: 0.08rem;
  }
  .recent-posts ul {
    min-height: 3.5rem;
  }
  .recent-posts li {
    padding: 0.32rem 0;
    border-bottom: 1px solid #dfdfdf;
  }
  .recent-posts li:last-child {
    border-bottom: 1px solid transparent;
  }
  .recent-posts .text-box {
    width: 1.93rem;
  }
  .recent-posts .img-box {
    width: 1rem;
    height: 0.86rem;
    flex: 0 0 auto;
  }
  .recent-posts .date {
    margin-top: 0.08rem;
    color: #8c8c8c !important;
    font-size: 0.12rem;
  }

  .related-products .img-box {
    height: auto;
    width: 70%;
    margin: 0.12rem auto 0.15rem;
  }
  .related-products .product-title {
    margin-bottom: 0.12rem;
    color: rgba(48, 129, 242, 0.9);
    font-style: italic;
  }
  .related-products .product-title:hover {
    color: rgba(48, 129, 242, 1);
  }
  .related-products .product-title .link-icon {
    width: 0.18rem;
    height: 0.19rem;
    margin-right: 0.08rem;
    background-image: url("data:image/svg+xml,%3Csvg width='18' height='19' viewBox='0 0 18 19' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.57 6.58c.249.25.27.641.062.915l-.062.07-1.647 1.647c-1.913 1.914-2.041 4.856-.328 6.57 1.668 1.667 4.501 1.59 6.416-.182l.153-.147 1.648-1.648a.697.697 0 0 1 1.048.914l-.062.071-1.648 1.648c-2.44 2.44-6.263 2.606-8.54.328-2.228-2.228-2.118-5.934.172-8.378l.156-.161L3.584 6.58a.697.697 0 0 1 .986 0zm11.82-4.594c2.228 2.228 2.118 5.934-.172 8.379l-.156.16-1.64 1.64a.697.697 0 0 1-1.047-.914l.062-.072 1.64-1.639c1.913-1.913 2.041-4.856.328-6.569-1.668-1.668-4.501-1.59-6.416.181l-.153.148-1.637 1.637a.697.697 0 0 1-1.048-.914l.062-.072L7.85 2.314c2.44-2.44 6.263-2.606 8.54-.328zm-4.822 4.703a.697.697 0 0 1 0 .986l-4.27 4.27a.697.697 0 1 1-.985-.986l4.27-4.27a.697.697 0 0 1 .985 0z' fill='%233081F2' fill-rule='evenodd'/%3E%3C/svg%3E");
  }

  :deep(.related-products-swiper-pagination.swiper-pagination-bullets) {
    top: 1.9rem;
    bottom: auto;
    z-index: 3;
    text-align: center;
    width: 100%;
  }
  :deep(.related-products-swiper-pagination.swiper-pagination-bullets .swiper-pagination-bullet) {
    width: 0.12rem;
    height: 0.02rem;
    background-color: rgba(214, 214, 214, 1);
    opacity: 0.4;
    border-radius: 2px;
    margin: 0 2px;
  }
  :deep(.related-products-swiper-pagination.swiper-pagination-bullets .swiper-pagination-bullet-active) {
    width: 0.22rem;
    opacity: 1;
  }

  .push-ads {
    display: none;
  }
  .push-ads .right-content-in {
    padding-bottom: 0;
  }
  .push-ads li {
    margin-bottom: 0.32rem;
  }
  .push-ads .img-box {
    height: auto;
    margin-bottom: 0.16rem;
    width: 3rem;
    height: 1.68rem;
  }
  .push-ads-title {
    margin-bottom: 0.08rem;
  }
  .push-ads .date {
    color: rgba(0, 0, 0, 0.45);
    font-size: 0.12rem;
  }
  .push-ads .date .tag {
    margin-right: 0.08rem;
    padding: 0 0.08rem;
    line-height: 0.24rem;
    background-color: rgba(204, 207, 210, 1);
    white-space: nowrap;
  }

  .right-share {
    border-radius: 0.08rem;
  }
  .right-share .right-content-in {
    padding-top: 0.12rem;
    padding-left: 0.24rem;
    padding-right: 0.24rem;
    padding-bottom: 0.24rem;
  }
  .right-share .share-container {
    margin-top: 0.16rem;
  }
  .right-share .share-container a {
    width: 0.32rem;
    height: 0.32rem;
    margin-left: 0;
    margin-right: 0.23rem;
    transition: transform 0.3s linear;
  }
  /* 图片描述 */
  .img-desc {
    color: #8c8c8c !important;
    font-size: 0.14rem !important;
    line-height: 1.5;
  }
  /* 引用 */
  .references {
    margin-top: 0.32rem !important;
    margin-bottom: 0.08rem !important;
    color: #262626 !important;
    font-size: 0.18rem;
  }
  .reference {
    font-size: 0.12rem;
    line-height: 1.5;
    color: #666;
  }
  .content p {
    line-height: 1.5;
  }
</style>

<style>
  .left-content {
    width: 8.43rem;
    border-radius: 0.08rem;
  }
  .left-content-in {
    padding: 0.22rem 0.32rem;
  }
  .left-content .main-title {
    font-size: 0.32rem;
    margin-bottom: 0.12rem;
    font-weight: 700;
  }
  .share-ico {
    transition: transform 0.3s;
    width: 0.24rem;
    height: 0.24rem;
    margin-right: 0.1rem;
    margin-left: 0.1rem;
  }
  .share-ico:hover {
    transform: scale(1.2);
  }
  .share-box .share-container a {
    width: 0.24rem;
    height: 0.24rem;
    margin: 0 0.1rem;
  }
  .left-content .date {
    margin-bottom: 0.32rem;
    color: #8c8c8c;
  }
  .article h2,
  .article h3,
  .article h4,
  .article h5,
  .article h6,
  .article h2 strong,
  .article h3 strong,
  .article h4 strong,
  .article h5 strong,
  .article h6 strong,
  .article h2 b,
  .article h3 b,
  .article h4 b,
  .article h5 b,
  .article h6 b {
    margin-bottom: 0.16rem;
    font-weight: 500 !important;
    color: rgba(0, 0, 0, 0.85);
  }
  .article h2 {
    font-size: 0.24rem !important;
    margin-top: 0.32rem !important;
    color: #262626 !important;
  }
  .article h3 {
    font-size: 0.2rem !important;
    margin-top: 0.16rem !important;
    color: #262626 !important;
  }
  .article h4,
  .article h5,
  .article h6 {
    font-size: 0.18rem !important;
    margin-top: 0.16rem !important;
  }
  .article h4 {
    color: #666 !important;
  }
  .article img {
    max-width: 100%;
    margin-top: 0.08rem;
    width: 7.79rem;
    height: 4.38rem;
  }
  .article p {
    margin-top: 0.16rem;
    color: #666;
  }

  .right-content {
    width: 3.33rem;
  }
  .right-content-in {
    padding: 0.24rem 0.16rem 0;
  }
  .related-products .right-content-in {
    padding: 0.24rem 0.16rem 0.32rem 0.16rem;
  }
  .right-title {
    font-size: 0.24rem;
  }
  .recent-posts,
  .related-products,
  .push-ads,
  .detail-share {
    margin-bottom: 0.24rem;
    border-radius: 0.08rem;
  }
  .recent-posts ul {
    min-height: 3.5rem;
  }
  .recent-posts li {
    padding: 0.32rem 0;
    border-bottom: 1px solid #dfdfdf;
  }
  .recent-posts li:last-child {
    border-bottom: 1px solid transparent;
  }
  .recent-posts .text-box {
    width: 1.93rem;
  }
  .recent-posts .img-box {
    width: 1rem;
    height: 0.86rem;
    flex: 0 0 auto;
  }
  .recent-posts .date {
    margin-top: 0.08rem;
    color: #8c8c8c !important;
    font-size: 0.12rem;
  }

  .related-products .img-box {
    height: auto;
    width: 70%;
    margin: 0.12rem auto 0.15rem;
  }
  .related-products .product-title {
    margin-bottom: 0.12rem;
    color: rgba(48, 129, 242, 0.9);
    font-style: italic;
  }
  .related-products .product-title:hover {
    color: rgba(48, 129, 242, 1);
  }
  .related-products .product-title .link-icon {
    width: 0.18rem;
    height: 0.19rem;
    margin-right: 0.08rem;
    background-image: url("data:image/svg+xml,%3Csvg width='18' height='19' viewBox='0 0 18 19' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.57 6.58c.249.25.27.641.062.915l-.062.07-1.647 1.647c-1.913 1.914-2.041 4.856-.328 6.57 1.668 1.667 4.501 1.59 6.416-.182l.153-.147 1.648-1.648a.697.697 0 0 1 1.048.914l-.062.071-1.648 1.648c-2.44 2.44-6.263 2.606-8.54.328-2.228-2.228-2.118-5.934.172-8.378l.156-.161L3.584 6.58a.697.697 0 0 1 .986 0zm11.82-4.594c2.228 2.228 2.118 5.934-.172 8.379l-.156.16-1.64 1.64a.697.697 0 0 1-1.047-.914l.062-.072 1.64-1.639c1.913-1.913 2.041-4.856.328-6.569-1.668-1.668-4.501-1.59-6.416.181l-.153.148-1.637 1.637a.697.697 0 0 1-1.048-.914l.062-.072L7.85 2.314c2.44-2.44 6.263-2.606 8.54-.328zm-4.822 4.703a.697.697 0 0 1 0 .986l-4.27 4.27a.697.697 0 1 1-.985-.986l4.27-4.27a.697.697 0 0 1 .985 0z' fill='%233081F2' fill-rule='evenodd'/%3E%3C/svg%3E");
  }
  .related-products-swiper-pagination.swiper-pagination-bullets {
    top: 1.9rem;
    bottom: auto;
    z-index: 3;
    text-align: center;
  }
  .related-products-swiper-pagination.swiper-pagination-bullets .swiper-pagination-bullet {
    width: 0.12rem;
    height: 0.02rem;
    background-color: rgba(214, 214, 214, 1);
    opacity: 0.4;
    border-radius: 2px;
    margin: 0 2px;
  }
  .related-products-swiper-pagination.swiper-pagination-bullets .swiper-pagination-bullet-active {
    width: 0.22rem;
    opacity: 1;
  }
  .related-products .leave-message {
    width: 1.2rem;
    height: 0.36rem;
    line-height: 0.36rem;
    margin-top: 0.48rem;
    font-size: 0.16rem;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #222222;
    transition: all 0.3s linear;
  }
  .related-products .leave-message:hover {
    background-color: rgba(0, 0, 0, 0.03);
  }

  .push-ads {
    display: none;
  }
  .push-ads .right-content-in {
    padding-bottom: 0;
  }
  .push-ads li {
    margin-bottom: 0.32rem;
  }
  .push-ads .img-box {
    height: auto;
    margin-bottom: 0.16rem;
    width: 3rem;
    height: 1.68rem;
  }
  .push-ads-title {
    margin-bottom: 0.08rem;
  }
  .push-ads .date {
    color: rgba(0, 0, 0, 0.45);
    font-size: 0.12rem;
  }
  .push-ads .date .tag {
    margin-right: 0.08rem;
    padding: 0 0.08rem;
    line-height: 0.24rem;
    background-color: rgba(204, 207, 210, 1);
    white-space: nowrap;
  }

  .right-share {
    border-radius: 0.08rem;
  }
  .right-share .right-content-in {
    padding-top: 0.12rem;
    padding-left: 0.24rem;
    padding-right: 0.24rem;
    padding-bottom: 0.24rem;
  }
  .right-share .share-container {
    margin-top: 0.16rem;
  }
  .right-share .share-container a {
    width: 0.32rem;
    height: 0.32rem;
    margin-left: 0;
    margin-right: 0.23rem;
    transition: transform 0.3s linear;
  }
  /* 图片描述 */
  .img-desc {
    color: #8c8c8c !important;
    font-size: 0.14rem !important;
    line-height: 1.5;
  }
  /* 引用 */
  .references {
    margin-top: 0.32rem !important;
    margin-bottom: 0.08rem !important;
    color: #262626 !important;
    font-size: 0.18rem;
  }
  .reference {
    font-size: 0.12rem;
    line-height: 1.5;
    color: #666;
  }
</style>
